module.exports = __webpack_public_path__ + "static/media/DAT-Otis Signature Service Logo.0b8a8e31.webp";